import { render, staticRenderFns } from "./AssemblyRegister.vue?vue&type=template&id=7f9a8d94&scoped=true"
import script from "./AssemblyRegister.vue?vue&type=script&lang=js"
export * from "./AssemblyRegister.vue?vue&type=script&lang=js"
import style0 from "./AssemblyRegister.vue?vue&type=style&index=0&id=7f9a8d94&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9a8d94",
  null
  
)

export default component.exports